module.exports = __webpack_public_path__ + "img/selected6-min.b88b1084.png";